export default __webpack_public_path__ + "static/product-b-press-gas-8099b9d1f0188381576eb909acafdfb4.jpg";